import React from 'react';
import FormContainer from '../../../Components/Form/FormContainer';
import InputField from '../../../Components/Form/components/InputField';
import NCZIReferenceSearchSelectField from './ReferenceSearchSelect/NCZIReferenceSearchSelectField';
import { NCZI_OID } from '../Enums/ncziOid.enum';
import { NCZIReferenceValidator } from './ReferenceSearchSelect/NCZIReferenceSearchSelect';
import * as yup from 'yup';
import { NCZIAddress } from '../Interfaces/ncziPatientInformations';
import InputWrapper from '../../../Components/Form/components/InputWrapper/InputWrapper';

const validateReferenceWithFilledAddress = (name: string) => {
	return yup.object().when('street', {
		is: (street: string) => street.length > 0,
		then: schema => NCZIReferenceValidator(name),
	});
};

export const NCZIAddressValidator = yup.object({
	street: yup.string(),
	descriptiveNumber: yup.string().when('street', {
		is: (street: string) => street.length > 0,
		then: schema => schema.required('registration.address.descriptiveNumber'),
	}),
	city: validateReferenceWithFilledAddress('registration.address.city'),
	country: validateReferenceWithFilledAddress('registration.address.country'),
	postCode: validateReferenceWithFilledAddress('registration.address.postCode'),
	region: validateReferenceWithFilledAddress('registration.address.region'),
});

export const fillAddressDefaultValues = (address: NCZIAddress | undefined) =>
	address
		? {
				street: address.street,
				descriptiveNumber: address.descriptiveNumber,
				country: {
					value: address.country,
					label: address.country?.displayName,
				},
				region: {
					value: address.region,
					label: address.region?.displayName,
				},
				postCode: {
					value: address.postCode,
					label: address.postCode?.displayName,
				},
				city: {
					value: address.city,
					label: address.city?.displayName,
				},
		  }
		: undefined;

const NCZIAddress: React.FC = () => {
	return (
		<FormContainer name={'address'}>
			<div className='row align-items-end'>
				<div className='col-md-6'>
					<InputWrapper>
						<InputField
							label='registration.address.street'
							name='street'
							isRequired
						/>
					</InputWrapper>
				</div>
				<div className='col-md-6'>
					<InputWrapper>
						<InputField
							label='registration.address.descriptiveNumber'
							name='descriptiveNumber'
							isRequired
						/>
					</InputWrapper>
				</div>
			</div>
			<div className='row align-items-end'>
				<div className='col-md-6'>
					<InputWrapper>
						<NCZIReferenceSearchSelectField
							name='city'
							label='registration.address.city'
							oid={NCZI_OID.CITY}
							isRequired
						/>
					</InputWrapper>
				</div>
				<div className='col-md-6'>
					<InputWrapper>
						<NCZIReferenceSearchSelectField
							name='postCode'
							label='registration.address.postCode'
							oid={NCZI_OID.POST_CODE}
							isRequired
						/>
					</InputWrapper>
				</div>
			</div>
			<div className='row align-items-end'>
				<div className='col-md-6'>
					<InputWrapper>
						<NCZIReferenceSearchSelectField
							name='region'
							label='registration.address.region'
							oid={NCZI_OID.REGION}
							isRequired
						/>
					</InputWrapper>
				</div>
				<div className='col-md-6'>
					<InputWrapper>
						<NCZIReferenceSearchSelectField
							name='country'
							label='registration.address.country'
							oid={NCZI_OID.COUNTRY}
							isRequired
						/>
					</InputWrapper>
				</div>
			</div>
		</FormContainer>
	);
};

export default NCZIAddress;
